/**
 * Set a timeout to do some operations to elements inside the cart block that are normally done on
 * page load. This timeout is necessary because WooCommerce loads the cart block asynchronously.
 */
(() => {
    let cart = document.querySelector('.wp-block-woocommerce-cart');

    if (!cart) {
        return;
    }

    setTimeout(() => {
        H_Tools?.links?.modifyLinks(cart);
    }, 4000);

    // do this fairly late, because products load slowly
    setTimeout(() => {
        H_Tools?.stickyheader?.makeBackwardsFocusable(cart);
    }, 6000);
})();
